import apiClient from "../web/ApiClient";

/**
 * Utility interface to represent a Researcher Interest as it comes from the API
 */
export interface ResearcherInterestsListing {
  interestId: number;
  description: string;
  sectionId: number;
  order: number;
  active: boolean;
}

/**
 * An interface to represent a researcher interest section
 */
export interface InterestSection {
  sectionType: string;
  sectionDescription: string;
  interests: ResearcherInterestsListing[];
  researcherInterestsIDs: number[];
}

/**
 * A mapping for the labels of each section
 */
export const SECTIONS = {
  ROLE_DESCRIPTION: "Describe your role",
  SPECIALITY_AREAS: "Relevant speciality areas",
  PROJECT_INTEREST: "Project Types",
} as const;

export type SectionKey = keyof typeof SECTIONS;

/**
 * We store this list so we don't have to recompute it all the time
 */
const loadedInterestSections: InterestSection[] = [];

/**
 * This function is used to lazily load the researcher interests list
 */
export async function loadInterestSections(researcherId: number): Promise<InterestSection[]> {
  // Return list if already computed
  if (loadedInterestSections.length > 0) {
    return loadedInterestSections;
  }

  await apiClient.get(`/ams/ui-api/v1/researchers/${researcherId}/interests`, {})
  .then((response) => {
    response.data.data.forEach((section: InterestSection) => {
      loadedInterestSections.push(section);
    })
  }).catch((error) => {
    console.warn(`Error when loading the researcher interests: ${error.message}`);
    return [];
  });

  return loadedInterestSections;
}
